import {FC} from 'react';
import {styled} from 'styled-components';

interface UploadProgressBarProps {
  progress: number;
}

export const UploadProgressBar: FC<UploadProgressBarProps> = ({progress}) => {
  return (
    <Wrapper>
      <Bar style={{width: `${progress}%`}} />
    </Wrapper>
  );
};

UploadProgressBar.displayName = 'UploadProgressBar';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 10px;
  background-color: #eee;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 8px;
`;

const Bar = styled.div`
  height: 100%;
  background-color: ${props => props.theme?.main?.accentColor || '#4caf50'};
  transition: width 0.2s ease;
`;
